import React from 'react'
import Assignments from './Assignments'
import styled from 'styled-components'

const ThumbsviewNav = ({
  thumbsviewNavbarMinified,
  setthumbsviewNavbarMinified,
}) => {
  return (
    <Wrapper width={thumbsviewNavbarMinified ? '111px' : '250px'}>
      <InnerWrapper>
        <Assignments
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          setthumbsviewNavbarMinified={setthumbsviewNavbarMinified}
        />
      </InnerWrapper>
    </Wrapper>
  )
}

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;
  width: 100%;
  height: ${(props) => props.height};
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  align-items: flex-start;
  overflow: hidden;
  width: ${(props) => props.width};
  transition: width 0.5s;
  height: ${(props) => props.height};
  background-color: rgb(37, 15, 67, 0.15);
`

export default ThumbsviewNav
